import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Params, UrlSegment } from "@angular/router";
import { ObjectUtils } from "../utils/object-utils";

export type BreadcrumbLink = {
    title: string;
    url: string;
    queryParams?: Params;
};

@Injectable({
    providedIn: "root"
})
export class BreadcrumbNavigationService {
    private _links: BreadcrumbLink[] = [];

    get links() {
        return this._links;
    }

    updateLinks(
        initialPath: ActivatedRouteSnapshot[],
        activatedRoute: ActivatedRouteSnapshot
    ) {
        const buildUrl = (reducedUrl: string, segments: UrlSegment[]) => {
            const partialUrl = segments.map(x => x.path).join("/");
            return `${reducedUrl}/${partialUrl}`;
        };

        let fullUrl = "";
        const initialLinks: BreadcrumbLink[] = initialPath.reduce((previous, snapshot) => {
            if(snapshot.url.length === 0) { // en route som ej går att navigera till
                return previous;
            }

            const title = snapshot.routeConfig?.title;
            fullUrl = buildUrl(fullUrl, snapshot.url);

            // om det inte finns en titel visar vi ej länken
            // (men tar ändå hänsyn till url-segmentet)
            if(ObjectUtils.isNullOrUndefined(title)) {
                return previous;
            }

            return [
                ...previous,
                { title,
                    url: fullUrl }
            ];
        }, []);

        const activeLink: BreadcrumbLink = {
            title: activatedRoute.routeConfig?.title as string,
            url: buildUrl(fullUrl, activatedRoute.url),
            queryParams: activatedRoute.queryParams
        };

        this._links = [
            ...initialLinks,
            ...(activeLink.title ? [activeLink] : [])
        ];
    }
}
